// extracted by mini-css-extract-plugin
export var container = "_gf-0";
export var content = "_gf-3";
export var customerTitle = "_gf-4";
export var empty = "_gf-5";
export var gray = "_gf-6";
export var header = "_gf-7";
export var info = "_gf-8";
export var loading = "_gf-2";
export var loadingCard = "_gf-9";
export var oneLine = "_gf-a";
export var personName = "_gf-e";
export var pillContainer = "_gf-b";
export var selected = "_gf-1";
export var text = "_gf-c";
export var twoLines = "_gf-d";
export var unread = "_gf-f";
export var unreadIndicator = "_gf-g";